module.exports = __webpack_public_path__ + "static/media/Seminar-nasional-new.d494d7af.jpeg";